import React, {Component} from 'react';
import Select from 'react-select';
import PropTypes from "prop-types";
import DesignPreviewContainer from "../utils/DesignPreviewContainer";
import StaticFunctions from "../utils/StaticFunctions";


class DesignSelector extends Component {

    static propTypes = {
        baseData:			PropTypes.object.isRequired,
        designs:			PropTypes.array.isRequired,
        onDesignSelected:	PropTypes.func.isRequired,
    };

    static defaultProps = {
        name:			'design-select',
        addAllOption:	false,
        designs:		[],
        optionLimit:	500,
    };

    constructor(props) {

        super(props);

        this.state = {
            currentCompanyId:		null,
            currentDesignId:		(this.props.addAllOption) ? 'all' : null,
			currentDesignStitches:	0,
            filterString:			''
        };

        this.translate		= this.props.translate;

        this.selectDesign	= this.selectDesign.bind(this);
        this.onInfoClick	= this.onInfoClick.bind(this);

    }

    componentDidMount() {

        if (this.props.currentDesign) {
            this.setState({
                currentDesignId:		this.props.currentDesign.designId,
                currentDesignStitches:	this.props.currentDesign.stitches,
            });
        }

    }

    selectDesign(option) {

        if (option) {
            const designId	= String(option.designId);
            const stitches	= String(option.stitches);

            option.name = this.props.name;

            this.setState({
                currentDesignId:		designId,
				currentDesignStitches:	stitches
            });

            if (this.props.onDesignSelected) this.props.onDesignSelected(option)
        }

    }

    onInfoClick() {

        alert(this.translate('designSelectionNote1') + '\n' + this.translate('designSelectionNote2') + '\n' + this.translate('designSelectionNote3'));

    }

	getSearchString() {

		const search = this.state.filterString.toLowerCase();

        return (search.length >= 3) ? search : '';

	}

    getOptions() {

        const designs		= this.props.designs ? this.props.designs : [];
        const sortedDesigns	= StaticFunctions.getSortedData(designs, 'id', 'string');
        const opt			= [];

        if (this.props.addAllOption) {
            opt.push({
                index:		'all',
                value:		'all',
                label:		this.translate('all'),
                name:		'All',
				stitches:	0
            });
        }

        return opt.concat(sortedDesigns.map((design, index) => {
			const img		= <DesignPreviewContainer baseData={this.props.baseData} designId={design.id} designStitches={design.stitches}/>;
			const designId	= String(design.id);
			const name		= (design.name) ? design.name : designId;
			const stitches	= (design.stitches) ? design.stitches : 0;

			return {
				index:		index,
				value:		designId + '_' + stitches,
				label:		<div>{img} {name} ({StaticFunctions.formatedNumber(stitches)} {this.translate('stitches')})</div>,
				name:		name + ' ' + stitches,
				designId:	designId,
				stitches:	parseInt(stitches)
			};
        }));

    }

	getSelectedDesign(designs = []) {

		let currentDesign	= (this.state.currentDesignId !== null) ? StaticFunctions.findObjectInArray(designs, 'designId', this.state.currentDesignId) : null;

		if (currentDesign !== null) {
			currentDesign	= (this.state.currentDesignStitches !== null) ? StaticFunctions.findObjectInArray(designs, 'stitches', this.state.currentDesignStitches) : null;
		}

		return currentDesign;
	}

    render() {

        const search		= this.getSearchString();
        const designs		= this.getOptions();
        const currentDesign	= this.getSelectedDesign(designs);

        let info = null;
        let opts = designs.filter((obj) => {
            const val		= obj.value.toLowerCase();
            const name		= obj.name.toLowerCase();
            const stitches	= obj.stitches.toString();
			const withAll	= (!search) ? (val === 'all') : false;

            return (val.includes(search) || name.includes(search) || stitches.includes(search) || withAll);
        });

        if (opts.length > this.props.optionLimit) {
            info	= <button className="infoButton" onClick={() => this.onInfoClick()} title={this.translate('showNote')}>&nbsp;</button>;
            opts	= opts.slice(0, this.props.optionLimit);

			if (currentDesign !== null) {
				const designIsInOpts = (this.getSelectedDesign(opts) !== null) || false;

				if (!designIsInOpts) opts.push(currentDesign);
			}
        }

        const selectedOption = currentDesign || null;

        return (
            <div className="bottomLinks">
                <Select
                    name={this.props.name}
                    className="chosen-container chosen-container-single"
                    style={{width: '260px'}}
                    options={opts}
                    onChange={this.selectDesign}
                    value={selectedOption}
                    placeholder={this.translate('select') + '...'}
                    clearable={false}
                    noResultsText={this.translate('noResultsFound')}
                    onInputChange={(filter) => this.setState({filterString: filter})}
                    filterOptions={(options) => options}
                />

                {info}
            </div>
        )

    }

}

export default DesignSelector;